<template>
  <LayoutPurchase>
    <template slot="purchaseOptions"  v-if="persistPurchaseOptions">
      <div class="subscription-container failable loadable" 
        :class="{
          failed: countries.error || purchaseOptions.error || invalidLink,
          loading: countries.loading || purchaseOptions.loading || fullLoading
        }"
      >
        <template v-if="!countries.error && !countries.loading && !invalidLink">
          <SubscriptionForm
            v-if="!purchaseOptions.error && !purchaseOptions.loading"
            :selected-country="selectedCountry"
            :purchase-options="purchaseOptions.data"
            :show-currency="showCurrency"
            @loadingChange="fullLoading = $event"
            @purchaseOptionSelectedChanged="purchaseOptionSelectedChangedHandler"
            :isOneTimePayment="true"
            :onlyOneOption="true"
            :view="view"
          />
        </template>
        <div class="failed-wrapper">
          <p class="error" v-if="invalidLink">
            {{$t('invalid_link')}}
            <br>
            <button type="button" @click="goBack">
              {{$t('dashboard.back')}}
            </button>
          </p>
          <p class="error" v-if="countries.error">
            {{$t('error')}}
            <br>
            <button type="button" @click="loadCountries">
              {{$t('retry')}}
            </button>
          </p>
          <div class="error" v-if="purchaseOptions.error">
            {{$t('country_error')}}
            <div style="margin-top: 2em"></div>
            <router-link class="btn main-btn" :to="{name: 'home'}">
              {{$t('back_to_home')}}
            </router-link>
          </div>
        </div>
        <div class="loader-wrapper">
          <Spinner/>
        </div>
      </div>
    </template>

    <template slot="disclaimers">
      <section class="disclaimers" style="margin-bottom: 0;">
        <router-link :to="{name: 'home'}">
          <div class="logo"></div>
        </router-link>
      </section>
    </template>
  </LayoutPurchase>
</template>

<script>
import SubscriptionForm from "../../components/Checkout/SubscriptionForm";
import PurchaseOptionLegals from "../../components/PurchaseOptionLegals";
import Spinner from "../../components/Spinner";

import LayoutPurchase from "../../layouts/LayoutPurchase";

import resources from "../../resources";
import { PurchaseView } from "../../types/enums";

export default {
  components: {
    PurchaseOptionLegals,
    SubscriptionForm,
    LayoutPurchase,
    Spinner,
  },
  props: {
    selectedCountry: {
      required: true,
      default: null,
    },
    showCurrency: {
      required: true,
      default: null,
    },
    countries: {
      required: true,
      type: Object,
      default: {
        data: [],
        loading: true,
        error: false,
      },
    },
  },
  data() {
    return {
      hash: this.$route.params.hash || "",
      webstar: this.$route.params.username.replace("@", "") || "",
      purchaseOptionSelected: null,
      purchaseOptions: {
        data: [],
        loading: true,
        error: false,
      },
      fullLoading: false,
      upgrade: false,
      persistPurchaseOptions: false,
      invalidLink: false,
      view: PurchaseView.paylink,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    purchaseOptionSelectedChangedHandler(purchaseOptionSelected) {
      this.purchaseOptionSelected = purchaseOptionSelected;
    },
    loadPurchaseOptions() {
      this.purchaseOptions = {
        data: [],
        error: false,
        loading: true,
      };

      resources.paylink
        .index({
          country_id: this.selectedCountry ? this.selectedCountry.id : "INT",
          username: this.webstar,
          hash: this.hash,
        })
        .then((paylinkResponse) => {

          console.log(paylinkResponse)

          if (paylinkResponse.data.error) {
            this.invalidLink = true;
            this.purchaseOptions = {
              data: [],
              error: false,
              loading: false,
            };
            return;
          };

          const paylink = paylinkResponse.data.data;
          const paylinkPlan = paylink.subscription_plan.data;

          resources.purchaseOptions
            .index({
              country_id: this.selectedCountry
                ? this.selectedCountry.id
                : "INT",
              include: [
                "subscription_plan.payment_methods",
                "subscription_plan.onward_subscription_plan",
                "subscription_plan.one_click_pay_cards",
              ],
              plan: paylinkPlan.id,
            })
            .then((response) => {
              const {
                onward_subscription_plan,
                payment_methods,
                one_click_pay_cards,
              } = response.data.data[0].subscription_plan.data;

              paylinkPlan.title = paylink.title;
              paylinkPlan.amount = paylink.amount;

              paylinkPlan.onward_subscription_plan = onward_subscription_plan;
              paylinkPlan.one_click_pay_cards = one_click_pay_cards;
              paylinkPlan.payment_methods = payment_methods;
              paylinkPlan.payment_link_id = paylink.id;

              this.purchaseOptions = {
                data: [paylink],
                error: false,
                loading: false,
              };
            })
            .catch((err) => {
              this.purchaseOptions = {
                data: [],
                error: true,
                loading: false,
              };
            });
        })
        .catch((err) => {
          let error = true;
          if (err.body.error === "Model and Hash dont match") {
            error = false;
            this.invalidLink = true;
          }

          this.purchaseOptions = {
            data: [],
            error: error,
            loading: false,
          };
        });
    },
    handlePersistPurchaseOptions() {
      if (this.persistPurchaseOptions) return;
      if (
        this.countries.loading ||
        this.purchaseOptions.loading ||
        this.fullLoading
      )
        return;

      this.persistPurchaseOptions = true;
    },
  },
  watch: {
    countries: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
    purchaseOptions: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
    fullLoading: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

// .payload-message-box {
//   margin: 0 0 50px 0;
//   max-width: 600px;
//   padding: 0 1em;
//   text-align: center;

//   .payload-message {
//     font-size: 1.4em;
//     width: 100%
//   }

//   .payload-message-author {
//     padding-top: 0.5em;
//     display: block;
//     font-size: 1.2em;
//     text-align: right;
//   }
// }

.error {
  text-align: center;
}

.subscription-container {
  min-height: 400px;
}

section.disclaimers {
  display: block;
  text-align: center;
  margin-top: 2em;
  margin-bottom: 2em;

  .logo {
    display: block;
    margin: auto;
    height: 50px;
    width: 100%;
    background-image: url("/img.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin-bottom: 50px;
  }

  .list {
    font-size: 1em;
    font-weight: bold;
  }
}
</style>
